export const API_PATH_ApiTrafficStudyPostReact = '/services/traffic-studies/apiTrafficStudyPostReact';
